// extracted by mini-css-extract-plugin
export default {"image":"TZ-z","loaded":"UZ-z"};